export var ApiFormCnst_RepoProdDefType;
(function (ApiFormCnst_RepoProdDefType) {
    ApiFormCnst_RepoProdDefType["ByTopic"] = "RepoProdDefType.bytopic";
    ApiFormCnst_RepoProdDefType["ByIndNames"] = "RepoProdDefType.byindnames";
    ApiFormCnst_RepoProdDefType["ByPattern"] = "RepoProdDefType.bypattern";
    ApiFormCnst_RepoProdDefType["ByReposAll"] = "RepoProdDefType.byreposall";
})(ApiFormCnst_RepoProdDefType || (ApiFormCnst_RepoProdDefType = {}));
;
export var ApiFormCnst_BranchProdDefType;
(function (ApiFormCnst_BranchProdDefType) {
    ApiFormCnst_BranchProdDefType["ByNameConv"] = "BranchProdDefType.bynameconv";
    ApiFormCnst_BranchProdDefType["ByPattern"] = "BranchProdDefType.bypattern";
    ApiFormCnst_BranchProdDefType["ByBranchAll"] = "BranchProdDefType.byBranchall";
    ApiFormCnst_BranchProdDefType["ByDefault"] = "BranchProdDefType.bydefault";
})(ApiFormCnst_BranchProdDefType || (ApiFormCnst_BranchProdDefType = {}));
;
export var ApiFormCtrlId_Ten_Assets;
(function (ApiFormCtrlId_Ten_Assets) {
    ApiFormCtrlId_Ten_Assets["LiveRepoDefType"] = "ApiFormCtrlId_Ten_Assets.LiveRepoDefType";
    ApiFormCtrlId_Ten_Assets["LiveRepoDefByTopic"] = "ApiFormCtrlId_Ten_Assets.LiveRepoDefByTopic";
    ApiFormCtrlId_Ten_Assets["LiveRepoDefByIndName"] = "ApiFormCtrlId_Ten_Assets.LiveRepoDefByIndName";
    ApiFormCtrlId_Ten_Assets["LiveRepoDefByPattern"] = "ApiFormCtrlId_Ten_Assets.LiveRepoDefByPattern";
    ApiFormCtrlId_Ten_Assets["LiveRepoDefByAll"] = "ApiFormCtrlId_Ten_Assets.LiveRepoDefByAll";
    ApiFormCtrlId_Ten_Assets["LiveBranchDefType"] = "ApiFormCtrlId_Ten_Assets.LiveBranchDefType";
    ApiFormCtrlId_Ten_Assets["LiveBranchDefByNameConv"] = "ApiFormCtrlId_Ten_Assets.LiveBranchDefByNameConv";
    ApiFormCtrlId_Ten_Assets["LiveBranchDefByPattern"] = "ApiFormCtrlId_Ten_Assets.LiveBranchDefByPattern";
    ApiFormCtrlId_Ten_Assets["LiveBranchDefByAll"] = "ApiFormCtrlId_Ten_Assets.LiveBranchDefByAll";
    ApiFormCtrlId_Ten_Assets["LiveBranchDefByDefault"] = "ApiFormCtrlId_Ten_Assets.LiveBranchDefByDefault";
    ApiFormCtrlId_Ten_Assets["FavouriteTopics"] = "ApiFormCtrlId_Ten_Assets.FavouriteTopic";
})(ApiFormCtrlId_Ten_Assets || (ApiFormCtrlId_Ten_Assets = {}));
